<div>
    <div class="blur">
        &nbsp;
    </div>
    <div class="InProgress">
        <img src="assets/images/load.gif" />
    </div>
</div>